// Centralized product data for YONO B2B — 3-family offering
// Families: Micro-habitats · Lodges compacts · Hébergements saisonniers

export function standardTech() {
  return {
    Type: "Modules bois massif habitables",
    Structure: "Panneaux CLT bois massif épicéa",
    "Épaisseur CLT": "60 mm",
    "Épaisseur murs totale": "140 mm",
    Isolation: "CLT 60 mm + fibre bois",
    Ventilation: "Extracteur + clapet",
    Chauffage: "Électrique, PAC en option",
    "Eau chaude": "Ballon 50 L",
    Menuiseries: "Bois, alu ou PVC",
    "Revêtement ext.": "Bardage épicéa teinté + tôle",
    Réseaux: "Eau, élec., eaux usées / trappe technique",
    Transport: "Préfabrication atelier, livraison camion",
  };
}

export const families = [
  {
    slug: "micro-habitats",
    index: "01 / 03",
    name: "Micro-habitats",
    short:
      "Valoriser les petits emplacements, créer une offre insolite, maximiser la rentabilité au m².",
    intro:
      "Des habitats autonomes et très compacts, pensés pour valoriser les petits emplacements, créer une offre insolite ou proposer des hébergements courts séjours avec une forte rentabilité au m².",
  },
  {
    slug: "lodges-compacts",
    index: "02 / 03",
    name: "Lodges",
    short:
      "L'alternative bois durable et architecturale au mobil-home traditionnel.",
    intro:
      "Des hébergements bois plus spacieux, conçus comme une alternative durable, chaleureuse et architecturale au mobil-home traditionnel.",
  },
  {
    slug: "hebergements-saisonniers",
    index: "03 / 03",
    name: "Hébergements saisonniers",
    short:
      "Loger les équipes directement sur site, dans des habitats bois sobres et prêts à raccorder.",
    intro:
      "Des solutions compactes et robustes pour loger les équipes directement sur site, dans des habitats bois confortables, simples à implanter et prêts à raccorder.",
  },
];

export const products = [
  // ── 1. Micro-habitats ─────────────────────────────────────────────────────
  {
    slug: "yono-micro",
    family: "micro-habitats",
    index: "01",
    name: "YONO Micro",
    seoTitle: "YONO Micro — Mini hébergement autonome",
    surface: "6 m²",
    capacity: "1 à 2 personnes",
    tagline: "Mini hébergement autonome avec couchage en mezzanine",
    short:
      "Une micro-unité autonome pour densifier intelligemment un parc et créer une offre insolite.",
    hero: "/images/joec44ol-chatgpt-image-2-juin-2026-a-10-36-24.webp",
    cardImage:
      "/images/joec44ol-chatgpt-image-2-juin-2026-a-10-36-24.webp",
    discoverImage:
      "/images/8iactbod-whatsapp-image-2026-06-03-at-11-42-20.webp",
    planImage:
      "/images/pup71hxg-yono-micro.webp",
    chips: ["6 m²", "1 à 2 personnes", "Mezzanine", "CLT bois massif"],
    intro:
      "Le plus compact des habitats YONO. Six mètres carrés conçus comme un mini logement autonome : kitchenette, salle d'eau et couchage en mezzanine. Une solution idéale pour valoriser un petit emplacement, créer une offre insolite ou proposer un format court séjour à forte rentabilité au m².",
    positioning:
      "Pensé pour les campings, PRL et domaines nature qui souhaitent créer une offre courte durée différenciante, densifier un parc existant ou exploiter des emplacements jusqu'ici inutilisés.",
    usages: [
      "Mini hébergement autonome",
      "Kitchenette intégrée",
      "Salle d'eau avec douche et WC",
      "Couchage en mezzanine",
      "Format insolite haute rentabilité",
      "Installation rapide sur emplacement existant",
      "Adapté aux campings, PRL et domaines nature",
    ],
    gallery: [
      "/images/joec44ol-chatgpt-image-2-juin-2026-a-10-36-24.webp",
      "/images/wdi4911d-a.webp",
      "/images/co8g45ud-b.webp",
      "/images/xml10x06-c.webp",
    ],
    priceHT: 15800,
    optionInsulation: 1490,
    optionMenuiseries: 390,
    tech: standardTech(),
    price: "Tarifs professionnels sur demande",
  },
  {
    slug: "yono-studio",
    family: "micro-habitats",
    index: "02",
    name: "YONO Studio",
    seoTitle: "YONO Studio — Micro-habitat bois pour couple",
    surface: "13 m²",
    capacity: "2 personnes",
    tagline: "Micro-habitat bois complet pour un couple",
    short:
      "Un micro-habitat bois confortable et chaleureux, pour un couple en court séjour.",
    hero: "/images/2zc3r290-whatsapp-image-2026-06-01-at-18-19-18.webp",
    cardImage:
      "/images/2zc3r290-whatsapp-image-2026-06-01-at-18-19-18.webp",
    discoverImage:
      "/images/bm9vithu-t1.webp",
    planImage:
      "/images/zityvh4m-yono-studio.webp",
    chips: ["13 m²", "2 personnes", "Mezzanine", "CLT 60 mm"],
    intro:
      "Le format le plus ouvert de la famille Micro-habitats. Un espace de vie généreux en rez-de-chaussée — banquette convertible, kitchenette et salle d'eau — complété par une mezzanine couchage qui libère le volume et renforce la sensation d'espace. Une solution compacte mais résolument confortable pour accueillir un couple dans un hébergement différenciant.",
    positioning:
      "Particulièrement adapté au court séjour locatif, aux campings premium, à l'hôtellerie de plein air haut de gamme et aux exploitants qui cherchent à élever leur offre.",
    usages: [
      "Séjour ouvert avec kitchenette intégrée",
      "Banquette convertible / coin détente",
      "Mezzanine couchage accessible par échelle bois",
      "Salle d'eau avec douche et WC",
      "Rangements intégrés selon configuration",
    ],
    gallery: [
      "/images/2zc3r290-whatsapp-image-2026-06-01-at-18-19-18.webp",
      "/images/6n3ymkh3-2.webp",
      "/images/insfduxi-3.webp",
      "/images/pstyqt55-4.webp",
      "/images/4a3l6ssj-whatsapp-image-2026-04-24-at-16-40-47-1.webp",
    ],
    priceHT: 22490,
    optionInsulation: 1490,
    optionMenuiseries: 490,
    optionAmenagement: { label: "Canapé convertible", price: 790 },
    tech: standardTech(),
    price: "Tarifs professionnels sur demande",
  },
  {
    slug: "yono-nido",
    family: "micro-habitats",
    index: "03",
    name: "YONO Nido",
    surface: "13 m²",
    capacity: "2 à 4 personnes",
    tagline: "Micro-habitat familial compact",
    short:
      "Une petite famille, un format optimisé : la rentabilité au m² au service de l'accueil familial.",
    hero: "/images/7tmx8rvg-chatgpt-image-2-juin-2026-a-14-32-23.webp",
    cardImage:
      "/images/7tmx8rvg-chatgpt-image-2-juin-2026-a-14-32-23.webp",
    discoverImage:
      "/images/lz3rr73o-chatgpt-image-25-avr-2026-a-17-22-05.webp",
    planImage:
      "/images/517wyrbf-yono-nido.webp",
    chips: ["13 m²", "2 à 4 personnes", "2 espaces nuit", "CLT 60 mm"],
    intro:
      "Le micro-habitat familial de la gamme. Treize mètres carrés pensés pour accueillir une petite famille sur une emprise réduite, sans renoncer au confort : chambre indépendante, séjour avec kitchenette, salle d'eau et couchages complémentaires. Une solution optimisée pour maximiser la capacité d'accueil et la rentabilité au m².",
    positioning:
      "Idéal pour les campings, l'hôtellerie de plein air et les domaines nature qui veulent proposer un format familial différenciant sur un emplacement compact.",
    usages: [
      "Séjour avec kitchenette intégrée",
      "Chambre indépendante en rez-de-chaussée",
      "Espace couchage complémentaire",
      "Salle d'eau avec douche et WC",
      "Rangements intégrés selon configuration",
      "Capacité jusqu'à 4 personnes sur 13 m²",
    ],
    gallery: [
      "/images/7tmx8rvg-chatgpt-image-2-juin-2026-a-14-32-23.webp",
      "/images/jao2sgw8-2.webp",
      "/images/uvvtivx1-3.webp",
      "/images/sxk2yx0t-4.webp",
      "/images/4a3l6ssj-whatsapp-image-2026-04-24-at-16-40-47-1.webp",
    ],
    priceHT: 23890,
    optionInsulation: 1490,
    optionMenuiseries: 490,
    optionAmenagement: { label: "Lit avec tiroirs", price: 490 },
    tech: standardTech(),
    price: "Tarifs professionnels sur demande",
  },

  // ── 2. Lodges compacts ───────────────────────────────────────────────────
  {
    slug: "yono-lodge",
    family: "lodges-compacts",
    index: "04",
    name: "YONO Lodge T3",
    seoTitle: "YONO Lodge T3 — Alternative bois mobil-home",
    surface: "22 m²",
    capacity: "4 personnes",
    tagline: "Hébergement bois compact — alternative au mobil-home",
    short:
      "Une alternative bois plus durable, plus qualitative et plus différenciante que le mobil-home.",
    hero: "/images/oizah5rt-1-1.webp",
    cardImage:
      "/images/oizah5rt-1-1.webp",
    discoverImage:
      "/images/oizah5rt-1-1.webp",
    planImage:
      "/images/ydgu116t-yono-lodge-t3.webp",
    planLarge: true,
    chips: ["22 m²", "4 personnes", "Plain-pied", "CLT bois massif"],
    intro:
      "Vingt-deux mètres carrés pensés pour quatre personnes, le YONO Lodge a été conçu pour concurrencer le mobil-home avec une proposition plus qualitative, plus durable et plus chaleureuse. Une enveloppe bois architecturale, des matériaux biosourcés et un confort d'usage à la hauteur des standards de l'hôtellerie de plein air.",
    positioning:
      "Adapté aux campings premium, PRL, parcs résidentiels de loisirs et domaines nature qui souhaitent remplacer progressivement leur parc de mobil-homes par des hébergements bois différenciants.",
    usages: [
      "Séjour avec kitchenette équipée",
      "Plusieurs espaces nuit selon configuration",
      "Salle d'eau avec douche et WC",
      "Capacité 4 personnes",
      "Architecture bois durable",
      "Alternative qualitative au mobil-home",
      "Prêt à raccorder",
    ],
    gallery: [
      "/images/oizah5rt-1-1.webp",
      "/images/u24igthk-2.webp",
      "/images/ql92x3zr-chatgpt-image-3-juin-2026-a-08-26-57.webp",
      "/images/dtunzpw0-chatgpt-image-2-juin-2026-a-14-59-47.webp",
    ],
    priceHT: 34900,
    optionInsulation: 2490,
    optionMenuiseries: 790,
    optionAmenagement: {
      label: "Lit double avec tiroirs + canapé séjour + lit superposé",
      price: 1190,
    },
    tech: standardTech(),
    price: "Tarifs professionnels sur demande",
  },
  {
    slug: "yono-family-lodge",
    family: "lodges-compacts",
    index: "05",
    name: "YONO Lodge T4",
    seoTitle: "YONO Lodge T4 — Logement bois familial",
    surface: "32 m² et +",
    capacity: "6 personnes",
    tagline: "Grand logement bois familial pour séjours longue durée",
    short:
      "Un véritable logement de vacances en bois pour les familles et les séjours longue durée.",
    hero: "/images/bi0phwnj-image-yono-lodge-t4.webp",
    cardImage:
      "/images/bi0phwnj-image-yono-lodge-t4.webp",
    discoverImage:
      "/images/esedg53n-image-yono-lodge-t4.webp",
    chips: [
      "32 m² et +",
      "6 personnes",
      "2 volumes CLT",
      "Véranda centrale",
    ],
    intro:
      "Le plus grand format de la gamme. Le YONO Lodge T4 associe deux volumes CLT reliés par une véranda lumineuse pour créer un véritable logement de vacances en bois. Trente-deux mètres carrés et plus pour accueillir jusqu'à six personnes dans une configuration spacieuse, lumineuse et confortable — pensée pour les séjours plus longs et les familles.",
    positioning:
      "Offre premium destinée aux campings haut de gamme, PRL et domaines nature qui souhaitent proposer un véritable logement de vacances en bois, en complément ou en remplacement d'un parc traditionnel.",
    usages: [
      "Deux volumes CLT reliés par une véranda",
      "Capacité 6 personnes",
      "Véritable espace de vie",
      "Plusieurs zones nuit selon configuration",
      "Cuisine équipée",
      "Salle d'eau avec douche et WC",
      "Grande luminosité naturelle",
      "Adapté à l'hôtellerie de plein air premium",
    ],
    gallery: [
      "/images/bi0phwnj-image-yono-lodge-t4.webp",
      "/images/k3g6fli6-chatgpt-image-29-mai-2026-a-15-37-51.webp",
      "/images/hkt87tvm-chatgpt-image-2-juin-2026-a-11-57-46.webp",
      "/images/23cnmmig-chatgpt-image-9-mai-2026-a-12-11-48.webp",
      "/images/lbid16zd-chatgpt-image-9-mai-2026-a-12-01-19.webp",
    ],
    tech: {
      Type: "Habitats bois massif habitables — grand format",
      Capacité: "6 personnes",
      Structure: "Panneaux CLT bois massif épicéa",
      "Épaisseur CLT": "60 mm",
      "Épaisseur murs totale": "140 mm",
      Isolation: "CLT 60 mm + fibre de bois",
      Ventilation: "Extracteur + clapet",
      Chauffage: "Électrique, PAC en option",
      "Eau chaude": "Ballon 50 L",
      Menuiseries: "Bois, aluminium ou PVC selon configuration",
      "Revêtement extérieur": "Bardage épicéa teinté + couverture métallique",
      Configuration: "2 volumes CLT + véranda centrale",
    },
    priceHT: 47900,
    optionInsulation: 3200,
    optionMenuiseries: 890,
    optionAmenagement: {
      label: "Lit double avec tiroirs + canapé séjour + 2× lits superposés",
      price: 1390,
    },
    price: "Tarifs professionnels sur demande",
  },

  // ── 3. Hébergements saisonniers ──────────────────────────────────────────
  {
    slug: "yono-twin",
    family: "hebergements-saisonniers",
    index: "06",
    name: "YONO Twin",
    seoTitle: "YONO Twin — Habitat bois personnel saisonnier",
    surface: "13 m²",
    capacity: "2 chambres",
    tagline: "Habitat bois pour le personnel saisonnier",
    short:
      "Deux chambres indépendantes et une salle d'eau centrale : loger les équipes sur site, simplement.",
    hero: "/images/36jp2xnd-chatgpt-image-2-juin-2026-a-15-19-49.webp",
    cardImage:
      "/images/36jp2xnd-chatgpt-image-2-juin-2026-a-15-19-49.webp",
    discoverImage:
      "/images/2bq6f9k3-t3.webp",
    planImage:
      "/images/3fh0xz63-yono-twin.webp",
    chips: [
      "13 m²",
      "2 chambres",
      "Salle d'eau centrale",
      "CLT 60 mm",
    ],
    intro:
      "Un habitat bois dédié à l'hébergement du personnel saisonnier. Deux chambres indépendantes, une salle d'eau centrale partagée et un format compact, sobre et efficace. Conçu pour loger les équipes directement sur site dans des conditions dignes, confortables et rapides à mettre en œuvre.",
    positioning:
      "Pensé pour les exploitants — campings, PRL, domaines nature, sites touristiques et hôtellerie de plein air — qui ont besoin de loger leur personnel saisonnier sur site dans des habitats bois durables et faciles à exploiter.",
    usages: [
      "Deux chambres indépendantes",
      "Salle d'eau centrale partagée",
      "Format compact pour personnel saisonnier",
      "Installation rapide sur emplacement existant",
      "Simple à raccorder",
      "Adapté aux campings, sites touristiques et exploitants saisonniers",
    ],
    gallery: [
      "/images/36jp2xnd-chatgpt-image-2-juin-2026-a-15-19-49.webp",
      "/images/jgrsnc9x-chatgpt-image-2-juin-2026-a-11-40-27.webp",
      "/images/igif2v06-2.webp",
      "/images/qrqd8wcg-t3.webp",
      "/images/wwbfhjcq-4.webp",
      "/images/tr3fw7d1-5.webp",
    ],
    priceHT: 23890,
    optionInsulation: 1490,
    optionMenuiseries: 490,
    optionAmenagement: {
      label: "Lit simple dans chaque chambre",
      price: 490,
    },
    tech: standardTech(),
    price: "Tarifs professionnels sur demande",
  },
];

export function getProduct(slug) {
  return products.find((p) => p.slug === slug);
}

export function getFamily(slug) {
  return families.find((f) => f.slug === slug);
}

export function getProductsByFamily(slug) {
  return products.filter((p) => p.family === slug);
}
